/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeduplicationRequest
 */
export interface DeduplicationRequest {
    /**
     * 
     * @type {string}
     * @memberof DeduplicationRequest
     */
    instanceId?: string;
    /**
     * 
     * @type {string}
     * @memberof DeduplicationRequest
     */
    entityType?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof DeduplicationRequest
     */
    entityIds?: Array<string>;
}

/**
 * Check if a given object implements the DeduplicationRequest interface.
 */
export function instanceOfDeduplicationRequest(value: object): value is DeduplicationRequest {
    return true;
}

export function DeduplicationRequestFromJSON(json: any): DeduplicationRequest {
    return DeduplicationRequestFromJSONTyped(json, false);
}

export function DeduplicationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeduplicationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'instanceId': json['instanceId'] == null ? undefined : json['instanceId'],
        'entityType': json['entityType'] == null ? undefined : json['entityType'],
        'entityIds': json['entityIds'] == null ? undefined : json['entityIds'],
    };
}

export function DeduplicationRequestToJSON(json: any): DeduplicationRequest {
    return DeduplicationRequestToJSONTyped(json, false);
}

export function DeduplicationRequestToJSONTyped(value?: DeduplicationRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'instanceId': value['instanceId'],
        'entityType': value['entityType'],
        'entityIds': value['entityIds'],
    };
}

